/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Ob der Versicherungsnehmer im öffentlichen Dienst beschäftigt oder verbeamtet ist; einige Versicherer tarifieren das günstiger.
 */
export enum Beschaeftigungsart {

    Normal = 'Normal',

    OeffentlicherDienst = 'OeffentlicherDienst'
}

